import React from 'react';
import { PlanStore } from "../store/planStore";
import { AccessStore } from "../store/accessStore";
import { SubStore } from "../store/subStore";
import Success from "./success";
import Failure from './failure';
import { ErrorStore } from '../store/errorStore';
import { RedirectStore } from '../store/redirectStore';

  

const Status = (props) => {

    const paidplan = PlanStore.useState((s)=>s.plan);
    const accessplan = AccessStore.useState((s)=>s.accessPlan);
    const errorPlan  = ErrorStore.useState((s)=>s.error);
    const selectedPlan = SubStore.useState((s) => s.selectPrice);
    const navigate = RedirectStore.useState((s) => s.redirectPlan);
    

    if((paidplan || accessplan) && props.match.params.flag==="success")
    {
        return(<Success plan={selectedPlan} paid={paidplan} {...props} redirect ={navigate}></Success>)
    }
    else
    {
        
      if(props.match.params.flag==="revoked")
      {
         
      }
      else
      {
        return(<Failure {...props} error={errorPlan}></Failure>)
      }
    }

    
};

export default Status;